import { useMemo, useState } from 'react'
import { filterSelectOptions } from './text'
import type { SelectOption } from './types'

/**
 * Search query state and derived options for searchable selects.
 */
export const useSearchableSelectState = (options: SelectOption[]) => {
  const [query, setQuery] = useState('')
  const filteredOptions = useMemo(() => filterSelectOptions(options, query), [options, query])

  return {
    query,
    setQuery,
    filteredOptions,
    resetQuery: () => setQuery(''),
  }
}

